import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseGenerico } from '../model/response-generico';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilesService {
  endpoint = "";
  constructor(private _conf:ConfigurationService,private _http:HttpClient) {
    this.endpoint = _conf.getConfiguration().hostapi + this._conf.getConfiguration().endpoints.roles.path
   }

   getCatalogoPerfiles():Observable<ResponseGenerico>{
     return this._http.get<ResponseGenerico>(this.endpoint);
   }
}
